module.exports = __webpack_public_path__ + "static/media/logo aulab.c0f91e28.png";